import template from './form.html';
import nuevoClienteTemplate from './cliente.nuevo.html';
import nuevoAtributoClienteTemplate from './atributo-cliente.nuevo.html';
import eventoTemplate from './evento.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import { formatErrorMessage } from 'core/util';
import citasI18N from 'i18n/citas/es.json';
import commonI18N from 'i18n/common/es.json';
import { pad } from 'core/util';
import viewAtributosTemplate from "./view-atributos.html";

export let CitaFormComponent = {
  templateUrl: template,
  selector: 'citaForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(citasI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', '$scope', 'CustomModal', 'AuthorizationService'
];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout, $scope, CustomModal, AuthorizationService) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);

  this.loadClientes = loadClientes.bind(this);
  this.loadServicios = loadServicios.bind(this);
  this.loadEspecialistas = loadEspecialistas.bind(this);
  this.loadEspecialistasNuevoDetalle = loadEspecialistasNuevoDetalle.bind(this);

  this.newDetalle = newDetalle.bind(this);
  this.deleteDetalle = deleteDetalle.bind(this);

  this.renderCliente = renderCliente.bind(this);
  this.renderServicio = renderServicio.bind(this);
  this.renderEspecialista = renderEspecialista.bind(this);
  this.renderEspecialistaTabla = renderEspecialistaTabla.bind(this);
  this.filterEspecialista = filterEspecialista.bind(this);
  this.filterServicio = filterServicio.bind(this);
  this.renderDisponibilidad = renderDisponibilidad.bind(this);
  this.onSelectEmpleado = onSelectEmpleado.bind(this);
  this.renderTipoAtributo = renderTipoAtributo.bind(this);
  this.loadTipoAtributo = loadTipoAtributo.bind(this);
  this.nuevoAtributoCliente = nuevoAtributoCliente.bind(this);
  this.viewAtributosCliente = viewAtributosCliente.bind(this);

  this.buscar = buscar.bind(this);

  this.checkHora = checkHora.bind(this);

  this.isObjectEmpty = function (o) {
    return Object.keys(o).length === 0;
  };

  this.$postLink = () => { };

  Object.assign(this, { $state, $ngRedux, ngNotify });

  this.localModel = {
    todosEspecialistas: true,
    seleccionPaquete: false,
    nuevoDetalle: {},
    detalles: {},
    ocupadas: {},
    fechaOptions: {
      minDate: new Date()
    },
    horarios: {}
  };

  let unsubscribe;
  const sexoQuery = Filter.path('tipo.codigo').eq('sexo');
  const tipoPersonaQuery = Filter.path('tipo.codigo').eq('tipo_persona');
  const tipoDocumentoQuery = Filter.path('tipo.codigo').eq('tipo_documento');
  const estadosFilter = Filter.path('tipo.codigo').eq('estado_cita');

  const valoresFilter = sexoQuery.or(tipoDocumentoQuery).or(tipoPersonaQuery).or(estadosFilter);
  const parametroFilter = Filter.path('codigo').eq('inicio_agenda_diaria').or(Filter.path('codigo').eq('fin_agenda_diaria'));

  const categoriaFilter = Filter.path('clase.value').eq('Servicio');

  this.$onDestroy = () => {
    this.form();
    this.nuevoClienteSelected = false;
    this.paquetesCliente = null;
    this.model.cliente = null;
    $ngRedux.dispatch(rest.actions.paquetesCliente.reset());
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
    this.nuevoClienteSelected = false;
    this.paquetesCliente = null;
    this.model.cliente = null;
    this.canCreateAtributoCliente = AuthorizationService.hasPermission('create_atributo_cliente');
    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver cita'] : this.translations['Editar cita'];
      this.formEdit('citas', $stateParams.uid);
    } else {
      this.title = this.translations['Nueva cita'];
      this.form();
      if ($stateParams.detalles) {
        //let detalle = $stateParams.detalles[0];
        // {
        //   especialista: $stateParams.especialista,
        //   servicio: $stateParams.servicio,
        //   fechaInicio: $stateParams.fecha,
        //   duracion: $stateParams.duracion || 30
        // };

        $stateParams.detalles.forEach((detalle) => {
          this.addEventoFromLanding(detalle);
        });

        $timeout(function () {
          $scope.$broadcast('init');
          angular.element('calendar').bind('contextmenu', event => event.preventDefault());
        }, 1500);
      }
    }

    $ngRedux.dispatch(rest.actions.parametros.get({ filter: JSON.stringify(parametroFilter) }));
    $ngRedux.dispatch(rest.actions.categoriasProductos({ filter: JSON.stringify(categoriaFilter) }));
    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));
  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    this.model = state.form.model;

    if (this.model && !this.model.id && state.valores.data && state.valores.data.length > 0) {
      this.estados = state.valores.data.filter(v => v.tipo.codigo === 'estado_cita');
      let estadoCreado = this.estados.filter(v => v.value === 'No Confirmada')[0];
      this.model.estado = estadoCreado;
      this.model.fecha = new Date();
      this.localModel.numero = this.translations['Autogenerado'];
      if (!this.model.detalles) {
        this.model.detalles = [];
      }
    } else if (!this.modelInit && this.model && this.model.id) {
      this.modelInit = true;
      this.model.detalles.forEach(function (detalle) {
        let id = moment.utc(detalle.fechaInicio, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYYHH:mm') + detalle.especialista.id;
        self.localModel.ocupadas[id] = true;
        let nuevoDetalle = Object.assign({}, detalle);
        nuevoDetalle.idLocal = id;
        self.localModel.detalles[id] = nuevoDetalle;
        // let evento = createEventFromDetalle(detalle, true);
        // evento.idLocal = id;
        // self.events.push(evento);
      });
      this.localModel.numero = this.model.numero;
    }

    if (!state.especialistas.loading && state.especialistas.data && state.especialistas.data.length) {
      this.especialistasPorCategoria = state.especialistas.data;
    }

    if (this.nuevoClienteSelected && !state.paquetesCliente.loading && state.paquetesCliente.data && state.paquetesCliente.data.length) {
      this.paquetesCliente = state.paquetesCliente.data;
      this.nuevoClienteSelected = false;
      ngNotify.set(this.translations['Existen Paquetes Disponibles'], {
        position: 'bottom',
        duration: 3000,
        type: 'info'
      });
    }

    if (state.parametros.data && state.parametros.data.length) {
      let inicio = state.parametros.data.filter((v) => v.codigo === 'inicio_agenda_diaria')[0];
      let fin = state.parametros.data.filter((v) => v.codigo === 'fin_agenda_diaria')[0];

      if (inicio) {
        this.localModel.horarios.inicio = inicio.valor.value + ':00';
      }

      if (fin) {
        this.localModel.horarios.fin = fin.valor.value + ':00';
      }

      //this.uiConfig.instance.fullCalendar('option', 'minTime', this.localModel.horarios.inicio);
      //this.uiConfig.instance.fullCalendar('option', 'maxTime', this.localModel.horarios.fin);
      this.uiConfig.calendar.minTime = this.localModel.horarios.inicio;
      this.uiConfig.calendar.maxTime = this.localModel.horarios.fin;
    }

    this.tiposPersona = state.valores.data.filter((v) => v.tipo.codigo === 'tipo_persona');

    return {
      form: state.form,
      categoriasProductos: state.categoriasProductos.data,
      tiposDocumento: state.valores.data.filter((v) => v.tipo.codigo === 'tipo_documento')
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   *
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.citas.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
      this.localModel.nuevoDetalle.especialista = null;
    }


    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go($stateParams.next ? $stateParams.next : 'home.citas.list');
    }
  }

  function doSubmit() {

    if (!Object.keys(this.localModel.detalles).length) {
      ngNotify.set(this.translations['Debe ingresar al menos un detalle'], 'warn');
      return;
    }

    //if (!this.checkHora()) return;

    let data = Object.assign({}, this.model);
    data.detalles = [];

    let fecha;
    // if (typeof data.fecha === 'string' || data.fecha instanceof String) {
    //   fecha = moment.utc(data.fecha, 'DD/MM/YYYY HH:mm');
    // }

    for (var key in self.localModel.detalles) {
      let detalle = Object.assign({}, self.localModel.detalles[key]);
      delete detalle.idLocal;
      if (this.localModel.seleccionPaquete) {
        detalle.paquete = { id: this.localModel.paqueteCliente.id };
      }
      detalle.servicio = detalle.servicio.id;
      data.detalles.push(detalle);

      if (!fecha) {
        fecha = moment.utc(detalle.fechaInicio, 'DD/MM/YYYY HH:mm');
      } else {
        let tmp = moment.utc(detalle.fechaInicio, 'DD/MM/YYYY HH:mm');
        fecha = tmp < fecha ? tmp : fecha;
      }
    }

    data.fecha = fecha.format('DD/MM/YYYY HH:mm');
    data.fechaAgendamiento = moment().format('DD/MM/YYYY HH:mm:ss');
    this.save('citas', data);
  }

  this.daysOfWeekMapHorarios = {
    0: 'horariosDomingos',
    1: 'horariosLunes',
    2: 'horariosMartes',
    3: 'horariosMiercoles',
    4: 'horariosJueves',
    5: 'horariosViernes',
    6: 'horariosSabados'
  };

  this.daysOfWeekMapHabilitados = {
    0: 'habilitadoDomingos',
    1: 'habilitadoLunes',
    2: 'habilitadoMartes',
    3: 'habilitadoMiercoles',
    4: 'habilitadoJueves',
    5: 'habilitadoViernes',
    6: 'habilitadoSabados'
  };

  this.checkDisponibilidad = checkDisponibilidad.bind(this);

  function checkDisponibilidad(disponibilidad, date) {
    let dayOfWeek = date.day();
    let habilitado = disponibilidad[this.daysOfWeekMapHabilitados[dayOfWeek]];
    if (!habilitado) return false;

    let horarios = disponibilidad[this.daysOfWeekMapHorarios[dayOfWeek]];
    let hour = date.hours();
    let min = date.minutes();
    if (min > 0) {
      hour = hour + 1;
    }

    let disponible = false;
    horarios.some(function (rango) {
      let hora2 = hour * 2;
      if (rango.inicio <= hora2 && rango.fin > hora2) {
        disponible = true;
        return true;
      }
    });

    return disponible;
  }


  function renderDisponibilidad(disponibilidad, date) {
    var weekDayName = date.format('dddd');
    let dayOfWeek = date.day();
    let horarios = disponibilidad[this.daysOfWeekMapHorarios[dayOfWeek]];
    let rangos = [];

    horarios.forEach(function (rango) {
      if (rango.inicio !== rango.fin) {
        let desde = `${pad(~~(rango.inicio / 2), 2)}:${rango.inicio % 2 ? '30' : '00'}`;
        let hasta = `${pad(~~(rango.fin / 2), 2)}:${rango.fin % 2 ? '30' : '00'}`;
        rangos.push(`De ${desde} hs. a ${hasta} hs.`);
      }
    });

    return `<strong>${weekDayName}:</strong> ${disponibilidad[this.daysOfWeekMapHabilitados[dayOfWeek]] ? rangos.join(' - ') : 'No Disponible'}`;
  }

  function renderEspecialista(empleado) {
    return `<div class="especialista-cita">${empleado.nombre} ${empleado.apellido} <div class="select-detalles"><small>${this.renderDisponibilidad(empleado.disponibilidad, this.localModel.nuevoDetalle.fechaInicio)}<small/></div></div>`;
  }

  function renderEspecialistaTabla(empleado) {
    return `${empleado.nombre} ${empleado.apellido}`;
  }

  function renderCliente(cliente) {
    let detalle = cliente.numeroDocumento ? `<small><strong>(${cliente.numeroDocumento})</strong></small>` : '';
    return `${cliente.razonSocial} ${detalle}`;
  }

  function checkHora() {

    let fecha = new Date(this.model.fecha.getTime());
    let hora = this.model.hora.split(':');

    fecha.setHours(hora[0]);
    fecha.setMinutes(hora[1]);

    if (fecha.getTime() < this.localModel.fechaOptions.minDate.getTime()) {
      ngNotify.set(self.translations['Cita con fecha/hora anterior'], 'warn');
      return false;
    }

    return true;
  }

  function newDetalle() {
    this.model.detalles.push({});
  }

  function deleteDetalle(detalle) {
    //_.remove(this.model.detalles, detalle);
    delete this.localModel.detalles[detalle.idLocal];
    delete this.localModel.ocupadas[detalle.idLocal];

    self.events.forEach(function (value, index) {
      if (value.idLocal === detalle.idLocal) {
        self.events.splice(index, 1);
      }
    });

    self.uiConfig.instance.fullCalendar('removeEvents', function (e) {
      return e.idLocal === detalle.idLocal;
    });
  }

  function renderServicio(item) {
    return `${item.nombre}`;
  }

  function loadServicios(query, categoria) {
    if (!categoria) {
      return;
    }

    let filter = Filter.path('categoria.id').eq(categoria.id)
      .and(Filter.path('activo').eq(true))
      .and(Filter.path('estado.value').eq('Activo'))
      .and(Filter.path('servicioPadre.id').isNull());

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  this.fieldsToShowEspecialista = ['nombre', 'apellido'];

  this.especialistasFilter = {};

  function filterEspecialista(especialista) {
    if (!especialista.disponibilidad) {
      return false;
    } else {
      if (this.especialistasFilter[especialista.id]) {
        return false;
      } else {
        this.especialistasFilter[especialista.id] = true;
        return this.checkDisponibilidad(especialista.disponibilidad, self.localModel.nuevoDetalle.fechaInicio) &&
          !(this.idsEspecialistasSolapados || []).includes(especialista.id);
      }
    }
  }

  this.filterEspecialistaGeneral = filterEspecialistaGeneral.bind(this);

  function filterEspecialistaGeneral(especialista) {
    if (!especialista.disponibilidad) {
      return false;
    } else {
      if (this.especialistasFilter[especialista.id]) {
        return false;
      } else {
        this.especialistasFilter[especialista.id] = true;
        return true;
      }
    }
  }

  function filterServicio(servicio) {
    return servicio.precio;
  }

  function onSelectEmpleado(detalle) {
    let dayOfWeek = this.model.fecha.getDay();

    if (!detalle.especialista.disponibilidad[this.daysOfWeekMapHabilitados[dayOfWeek]]) {
      ngNotify.set(this.translations['Especialista no disponible en fecha/hora seleccionados'], 'warn');
      detalle.especialista = undefined;
      return;
    }

    if (!this.model.hora) {
      ngNotify.set(this.translations['Seleccione un horario para la Cita'], 'warn');
      detalle.especialista = undefined;
      return;
    }

    let horarios = detalle.especialista.disponibilidad[this.daysOfWeekMapHorarios[dayOfWeek]];
    let hora = this.model.hora.split(':')[0];

    let enHorario = horarios.some(function (rango) {
      return (hora >= rango.inicio && hora <= rango.fin);
    });

    if (!enHorario) {
      ngNotify.set(this.translations['Horario no disponible para Especialista'], 'warn');
      detalle.especialista = undefined;
      return;
    }
  }

  function loadEspecialistas(query, detalle) {
    let especialidades = [];
    if (!detalle || !detalle.servicio) return;

    detalle.servicio.especialidades.forEach(function (especialidad) {
      especialidades.push(especialidad.id);
    });

    this.especialistasFilter = {};

    let filter = Filter.path('tipoEmpleado.value').eq('Especialista')
      .and(Filter.path('activo').eq(true))
      .and(Filter.path('disponibilidad').notNull())
      .and(Filter.path('especialidades.id').in(especialidades));

    if (query) {
      let queries = query.split(' ');
      queries.forEach((query) => {
        if (query.length) {
          filter = filter.and(Filter.path('nombre').like(query)
            .or(Filter.path('apellido').like(query)));
        }
      });
    }

    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }


  function loadEspecialistasNuevoDetalle() {
    let detalle = this.localModel.nuevoDetalle;
    let especialidades = [];
    if (!detalle || !detalle.servicio) return;

    detalle.servicio.especialidades.forEach(function (especialidad) {
      especialidades.push(especialidad.id);
    });

    this.especialistasFilter = {};

    let filter = Filter.path('tipoEmpleado.value').eq('Especialista')
      .and(Filter.path('activo').eq(true))
      .and(Filter.path('disponibilidad').notNull())
      .and(Filter.path('especialidades.id').in(especialidades));

    $ngRedux.dispatch(rest.actions.especialistas.get({ filter: JSON.stringify(filter) }));
  }

  this.onSelectCliente = onSelectCliente.bind(this)
  function onSelectCliente() {
    this.nuevoClienteSelected = true;
    this.localModel.paqueteCliente = null;
    this.paquetesCliente = null;
    this.loadPaquetes();
  }

  this.fieldsToShowPaquetes = ['paquete.codigo', 'paquete.servicio.nombre'];
  this.loadPaquetes = loadPaquetes.bind(this)
  function loadPaquetes() {
    if (!this.model.cliente) return;

    this.paquetesFilter = {};

    let filter = Filter.path('estadoSesiones.value').like('Pendiente')
      .and(Filter.path('cliente.id').eq(this.model.cliente.id));

    $ngRedux.dispatch(rest.actions.paquetesCliente.get({ filter: JSON.stringify(filter) }));
  }

  function loadClientes(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('numeroDocumento').like(query))
        .or(Filter.path('tipoDocumento.value').like(query))
        .or(Filter.path('sexo.value').like(query))
        .or(Filter.path('telefono').like(query)));
    } else {
      return;
    }
    BasicFactory.setup('clientes');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  this.events = [];

  let self = this;
  this.uiConfig = {
    calendar: {
      height: 'auto',
      //height: 600,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultView: 'agendaDay',
      allDayText: this.translations['Todo el día'],
      buttonText: {
        today: this.translations['Hoy'],
        month: this.translations['Mes'],
        week: this.translations['Semana'],
        day: this.translations['Día'],
        list: this.translations['Lista']
      },
      allDaySlot: false,
      timeFormat: 'HH(:mm)',
      slotLabelFormat: 'HH(:mm)',
      minTime: this.localModel.horarios.inicio,
      maxTime: this.localModel.horarios.fin,
      //scrollTime: '08:00:00',
      slotDuration: '00:15:00',
      editable: false,
      longPressDelay: 100,
      eventLongPressDelay: 100,
      selectLongPressDelay: 100,
      slotEventOverlap: false,
      listDayAltFormat: true,
      droppable: false,
      // drop: function(date, jsEvent, ui, resourceId) { // this function is called when something is dropped
      //   console.log(date);
      //   // retrieve the dropped element's stored Event Object
      //   var originalEventObject = $(this).data('eventObject');
      //   // we need to copy it, so that multiple events don't have a reference to the same object
      //   var copiedEventObject = $.extend({}, originalEventObject);
      //   // assign it the date that was reported
      //   copiedEventObject.start = date;
      //   // render the event on the calendar
      //   // the last `true` argument determines if the event "sticks" (http://arshaw.com/fullcalendar/docs/event_rendering/renderEvent/)
      //   $('#calendario').fullCalendar('renderEvent', copiedEventObject, true);
      //   // is the "remove after drop" checkbox checked?
      //   if ($('#drop-remove').is(':checked')) {
      //     // if so, remove the element from the "Draggable Events" list
      //     $(this).remove();
      //   }
      // },
      defaultDate: new Date(),
      selectable: true,
      selectHelper: false,
      // selectConstraint: {
      //   start: moment().subtract(1, 'days'),
      //   end: moment().startOf('month').add(1, 'month')
      // },
      select: function (start, end, jsEvent, view) {
        // if (moment().diff(start, 'hours') > 0) {
        //   self.ngNotify.set(self.translations['Cita con fecha/hora anterior'], 'warn');
        //   return false;
        // }

        const idsEspecialistasSolapados =
          self.events.filter(e => {
            // Inicio y fin del evento que se va a analizar si se solapa o no con el nuevo evento que se quiere agregar
            const eventStart = moment.utc(e.start);
            const eventEnd = moment.utc(e.end);
            // Condicion de solapamiento, si es true, se solapan
            return e.especialista
              && (
                eventStart.isBetween(start, end, undefined, '()')
                ||
                start.isBetween(eventStart, eventEnd, undefined, '()')
              );
          }).map(e => e.especialista);

        self.idsEspecialistasSolapados = idsEspecialistasSolapados;

        let id = false;
        if (self.localModel.nuevoDetalle.especialista) {
          id = start.format('DD/MM/YYYYHH:mm') + self.localModel.nuevoDetalle.especialista.id;
        }

        let minuto = start.minutes();
        if (!self.isOverlap && minuto !== 0 && minuto !== 30) {
          self.ngNotify.set(self.translations['Cita debe empezar al minuto'], 'warn');
          return false;
        }

        if (self.isOverlap && minuto !== 15 && minuto !== 45 && (id && self.localModel.ocupadas[id])) {
          self.ngNotify.set(self.translations['Cita solapada debe empezar al minuto'], 'warn');
          return false;
        }

        self.isOverlap = false;
        if ((view.name === 'agendaDay' || view.name === 'agendaWeek') && self.uiConfig.allowSelect) {
          self.uiConfig.allowSelect = false;
          self.addEvent(start, end);
        }
      },
      selectOverlap: function (event) {
        if (!event.disponibilidad) self.isOverlap = true;

        self.uiConfig.allowSelect = true;
        return true;
      },
      dayClick: function (date, jsEvent, view) {
        if (view.name === 'month') {
          self.uiConfig.instance.fullCalendar('gotoDate', date);
          self.uiConfig.instance.fullCalendar('changeView', 'agendaDay');
        }
      },
      eventClick: function (event, jsEvent, view) {
        if (view.name === 'month') {
          self.uiConfig.instance.fullCalendar('gotoDate', event.start);
          self.uiConfig.instance.fullCalendar('changeView', 'agendaDay');
          return;
        }

        if (!event.editable) return;

        self.localModel.payload = self.localModel.detalles[event.idLocal];
        self.localModel.edicionEvent = event;

        let modalOptions = {
          title: 'Editar Cita Detalle',
          templateUrl: eventoTemplate,
          vm: self,
          payload: self.localModel.payload,
          ok: self.actualizarEvento,
          actionLabel: 'Guardar',
          actionLeftLabel: 'Borrar'
        };

        modalOptions.actionLeft = self.borrarEvento(modalOptions);
        CustomModal.open(modalOptions);
      },
      eventStartEditable: false,
      // eventDrop: function(event, revertFunc, jsEvent, ui, view) {
      //   console.log(event);
      //   self.actualizarEvento(event);
      //   console.log("Event Droped on " + event.start + " to " + event.end);
      // },
      eventResize: function (event, jsEvent, ui, view) {
        self.localModel.detalles[event.idLocal].duracion = event.end.diff(event.start, 'minutes');
      },
      eventAfterAllRender: function (view) {
        //$('html,body').animate({ scrollTop: $('#opciones').offset().top }, 500);
      },
      eventRender: function (event, element) {
        if (event.especilista) {
          element.attr('data-toggle', 'tooltip');
          element.attr('title', event.title);
          element.tooltip();
        }
      },
      viewRender: function (view, element) {
        // $('.fc-day').filter(function(index) {
        //   return moment($(this).data('date')).isBefore(moment(), 'day');
        // }).addClass('fc-disabled');
        self.uiConfig.instance.fullCalendar('removeEvents', function (e) {
          return true;
        });
        //get from view.intervalStart to view.intervalEnd
        self.getEventos(view.start, view.end, view.name);

      }
    }
  };

  function createEventFromDetalle(detalle, editable) {
    var d, date, m, y, min, hour, minutos;
    if (typeof detalle.fechaInicio === 'string' || detalle.fechaInicio instanceof String) {
      date = moment.utc(detalle.fechaInicio, 'DD/MM/YYYY HH:mm').toDate();
    } else if (detalle.fechaInicio.format) {
      date = detalle.fechaInicio.toDate();
    } else {
      date = detalle.fechaInicio;
    }

    d = date.getDate();
    m = date.getMonth();
    y = date.getFullYear();
    min = date.getMinutes();
    hour = date.getHours();

    minutos = min + detalle.duracion;

    return {
      title: `${detalle.especialista.nombre} / ${detalle.servicio.nombre}`,
      start: new Date(y, m, d, hour, min).toUTCString(),
      end: new Date(y, m, d, hour + (minutos / 60), minutos % 60).toUTCString(),
      allDay: false,
      editable: editable,
      className: editable ? ['cita'] : ['']
    };
  }

  this.selectCategoria = selectCategoria.bind(this);

  this.selectServicio = selectServicio.bind(this);
  this.reRenderCalendar = reRenderCalendar.bind(this);
  this.changeSeleccionEspecialista = changeSeleccionEspecialista.bind(this);

  function selectCategoria() {
    this.localModel.nuevoDetalle.servicio = null;
    this.reRenderCalendar();
  }


  function changeSeleccionEspecialista() {
    this.localModel.nuevoDetalle.especialista = null;
    this.reRenderCalendar();
  }

  function selectServicio() {
    this.localModel.nuevoDetalle.especialista = null;
    this.loadEspecialistasNuevoDetalle();
    this.reRenderCalendar();
  }

  function reRenderCalendar() {
    let view = self.uiConfig.instance.fullCalendar('getView');
    this.loading = true;

    $timeout(function () {
      self.getEventos(view.start, view.end, view.name);
      self.loading = false;
    }, 100);

    // self.uiConfig.instance.fullCalendar('removeEvents', function(e) {
    //   return true;
    // });
    // self.events.forEach(function(event) {
    //   self.uiConfig.instance.fullCalendar('removeEvent', event);
    // });

    //self.uiConfig.instance.fullCalendar('rerenderEvents');
  }

  this.getEventos = function (start, end, viewName) {
    let payload = {
      start,
      end
    };

    if (self.model && self.model.id) {
      payload.citaId = self.model.id;
    }

    if (self.localModel.categoria) {
      payload.categoriaServicioId = self.localModel.categoria.id;
    } else {
      return;
    }

    if (self.localModel.nuevoDetalle.servicio) {
      payload.servicioId = self.localModel.nuevoDetalle.servicio.id;
    } else {
      return;
    }

    if (!self.localModel.todosEspecialistas && self.localModel.nuevoDetalle.especialista) {
      payload.especialistaId = self.localModel.nuevoDetalle.especialista.id;
    }

    $ngRedux.dispatch(rest.actions.agenda({}, {
      body: JSON.stringify(payload)
    }, (err, data) => {
      if (!err) {
        self.events.splice(0, self.events.length);
        data.forEach(function (element) {
          if (element.disponibilidad) {
            // if (moment().diff(element.start, 'days') > 0) {
            //   return false;
            // }
            if (viewName !== 'month') {
              element.rendering = 'background';
            }
            element.title = self.translations['Disponible'];
            element.className = ['disponible', 'bg-blue-alt'];
          } else if (element.confirmada) {
            element.className = ['confirmada'];
          } else if (element.concretada) {
            element.className = ['concretada'];
          }

          if (element.especialista) {
            let id = moment.utc(element.start, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYYHH:mm') + element.especialista;
            self.localModel.ocupadas[id] = true;
          }

          self.events.push(element);
        });
      } else if (err) {
        ngNotify.set(err.message, 'warn');
      }

      for (var key in self.localModel.detalles) {
        let detalle = self.localModel.detalles[key];
        let evento = createEventFromDetalle(detalle, true);
        evento.idLocal = key;
        self.events.push(evento);
      }
    }));
  };

  // $scope.alertOnDrop = function(event, revertFunc, jsEvent, ui, view) {
  //   console.log(event);
  //   $scope.actualizarEvento(event);
  //   //$scope.alertMessage = "Event Droped on " + event.start.format() + " to " +  event.end.format();
  // };

  // $scope.addRemoveEventSource = function(sources, source) {
  //   var canAdd;
  //   canAdd = 0;
  //   angular.forEach(sources, function(value, key) {
  //     if (sources[key] === source) {
  //       sources.splice(key, 1);
  //       canAdd = 1;
  //     }
  //   });
  //   if (canAdd === 0) {
  //     sources.push(source);
  //   }
  // };

  this.addEvent = function (start, end) {
    if (!self.localModel.nuevoDetalle.servicio) {
      ngNotify.set(this.translations['Seleccionar Servicio'], 'warn');
      return;
    }

    if (self.localModel.seleccionPaquete && Object.keys(self.localModel.detalles).length >= 1) {
      ngNotify.set(this.translations['Paquete Agendado'], 'warn');
      return;
    }

    self.localModel.nuevoDetalle.fechaInicio = start;
    self.localModel.nuevoDetalle.end = end;
    self.localModel.nuevoDetalle.duracion = 30;

    self.localModel.edicionEvent = null;

    let modalOptions = {
      title: 'Nueva Cita Detalle',
      templateUrl: eventoTemplate,
      vm: self,
      seleccionarEspecialista: !self.localModel.nuevoDetalle.especialista || self.localModel.todosEspecialistas,
      payload: self.localModel.nuevoDetalle,
      ok: self.actualizarEvento,
      actionLabel: 'Guardar',
      onChangeDuracion: () => {
        let duracion = self.localModel.nuevoDetalle.duracion;
        let fechaInicio = self.localModel.nuevoDetalle.fechaInicio;
        let fechaFin = moment(fechaInicio).add(duracion, 'm').toDate();
        let horaLimite = moment('23:00', 'HH:mm');
        let fechaLimite = moment(fechaInicio).set({
          hour: horaLimite.get('hour'),
          minute: horaLimite.get('minute')
        }).toDate();

        if (fechaFin > fechaLimite) {
          self.localModel.duracionWarning = 'La duración parece muy grande, está seguro?';
        } else {
          self.localModel.duracionWarning = null;
        }
      },
    };

    CustomModal.open(modalOptions);
  };

  this.onSelectEspecialista = onSelectEspecialista.bind(this);

  function onSelectEspecialista(payload) {
    this.localModel.nuevoDetalle.especialista = payload.especialista;
  }

  this.borrarEvento = function (modal) {
    function borrar(evento) {
      if (!evento) {
        evento = self.localModel.payload;
      }
      delete self.localModel.detalles[evento.idLocal];
      delete self.localModel.ocupadas[evento.idLocal];

      self.events.forEach(function (value, index) {
        if (value.idLocal == evento.idLocal) {
          self.events.splice(index, 1);
        }
      });

      self.uiConfig.instance.fullCalendar('removeEvents', function (e) {
        return e.idLocal === evento.idLocal;
      });

      modal.close();
    }
    return borrar;
  };

  this.actualizarEvento = function (detalle) {
    if (!self.localModel.nuevoDetalle.especialista && !self.localModel.edicionEvent) return false;


    if (self.localModel.edicionEvent) {
      var d, date, m, y, min, hour, minutos;
      date = self.localModel.edicionEvent.start.toDate();
      d = date.getDate();
      m = date.getMonth();
      y = date.getFullYear();
      min = date.getMinutes();
      hour = date.getHours();

      minutos = min + self.localModel.payload.duracion;

      self.localModel.edicionEvent.end = new Date(y, m, d, hour + (minutos / 60), minutos % 60).toUTCString();
      self.uiConfig.instance.fullCalendar('updateEvent', self.localModel.edicionEvent);
      self.localModel.edicionEvent = null;

      return true;
    }

    let id = self.localModel.nuevoDetalle.fechaInicio.format('DD/MM/YYYYHH:mm') + self.localModel.nuevoDetalle.especialista.id;

    if (self.localModel.ocupadas[id]) {
      ngNotify.set(self.translations['Horario no disponible para Especialista'], 'warn');
      //self.localModel.nuevoDetalle.especialista = null;
      return false;
    }

    if (!detalle) {
      detalle = self.localModel.nuevoDetalle || self.localModel.payoad;
    }

    let evento = createEventFromDetalle(detalle, true);
    evento.idLocal = id;
    self.events.push(evento);
    self.localModel.ocupadas[id] = true;

    self.localModel.detalles[id] = {
      idLocal: id,
      servicio: self.localModel.nuevoDetalle.servicio,
      especialista: self.localModel.nuevoDetalle.especialista,
      fechaInicio: self.localModel.nuevoDetalle.fechaInicio.format('DD/MM/YYYY HH:mm'),
      duracion: self.localModel.nuevoDetalle.duracion
    };
    self.localModel.nuevoDetalle.especialista = null;
    return true;
  };

  this.addEventoFromLanding = addEventoFromLanding.bind(this);

  function addEventoFromLanding(detalle) {
    let evento = createEventFromDetalle(detalle, true);
    let parts = detalle.fechaInicio.split(' ');
    let id = parts[0] + parts[1] + detalle.especialista.id;

    evento.idLocal = id;
    this.events.push(evento);
    this.localModel.ocupadas[id] = true;

    this.localModel.detalles[id] = {
      idLocal: id,
      servicio: detalle.servicio,
      especialista: detalle.especialista,
      fechaInicio: detalle.fechaInicio,
      duracion: detalle.duracion
    };
  }

  // this.changeView = function(view, element) {
  //   self.uiConfig.instance.fullCalendar("changeView", view);
  // };

  this.updateRazonSocial = updateRazonSocial.bind(this);

  function updateRazonSocial() {
    this.localModel.payload.razonSocial = `${this.localModel.payload.nombre ? this.localModel.payload.nombre : ''} ${this.localModel.payload.apellido ? this.localModel.payload.apellido : ''}`;
  }


  this.nuevoCliente = nuevoCliente.bind(this);

  function nuevoCliente() {
    let self = this;
    this.localModel.payload = {};

    if (this.tiposDocumento) {
      this.localModel.payload.tipoDocumento = this.tiposDocumento.filter((tipo) => tipo.value === 'RUC')[0];
    }

    CustomModal.open({
      title: 'Nuevo Cliente',
      size: 'lg',
      templateUrl: nuevoClienteTemplate,
      backdrop: 'static',
      keyboard: false,
      vm: this,
      payload: this.localModel.payload,
      ok: function () {
        if (self.localModel.payload.tipoDocumento.name == "RUC") {
          self.localModel.payload.numeroDocumento = self.localModel.payload.numeroDocumento + "-"+self.localModel.payload.ruc.digitoVerificador;
          $ngRedux.dispatch(rest.actions.clientes({}, { body: JSON.stringify(self.localModel.payload) },
            (err, data) => {
              if (!err && data && data.id) {
                self.model.cliente = data;
                ngNotify.set(self.translations['Nuevo Cliente Creado'], 'success');
              } else if (err) {
                ngNotify.set(err.message, 'warn');
              }
            }));
        } else {
          $ngRedux.dispatch(rest.actions.clientes({}, { body: JSON.stringify(self.localModel.payload) },
            (err, data) => {
              if (!err && data && data.id) {
                self.model.cliente = data;
                ngNotify.set(self.translations['Nuevo Cliente Creado'], 'success');
              } else if (err) {
                ngNotify.set(err.message, 'warn');
              }
            }));
        }
      }
    });
  }

  function nuevoAtributoCliente() {
    let self = this;
    CustomModal.open({
      title: 'Nuevo Atributo de Cliente',
      size: 'lg',
      templateUrl: nuevoAtributoClienteTemplate,
      backdrop: 'static',
      keyboard: false,
      vm: this,
      payload: { cliente: this.model.cliente, origen: 'CITA' },
      ok: function () {
        const campos = (this.payload.tipo && this.payload.tipo.campos) || [];
        const valor = this.payload.valor || {};
        const camposRequeridosCompletados = campos
          .filter(c => c.requiredCita)
          .map(c => c.text)
          .reduce((camposRequeridosCompletados, campoRequerido) => {
            return camposRequeridosCompletados && valor[campoRequerido];
          }, true);

        if (!camposRequeridosCompletados) {
          ngNotify.set('Campos requeridos faltantes', 'warn');
          return false;
        }

        $ngRedux.dispatch(rest.actions.atributosClientes({}, { body: JSON.stringify(this.payload) },
          (err, data) => {
            if (!err && data) {
              self.model.cliente.atributos.push(data);
              ngNotify.set(self.translations['Nuevo Atributo de Cliente Creado'], 'success');
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
      }

    });
  }

  function viewAtributosCliente() {
    let self = this;

    // Eliminar la hora de las fechas
    (self.model.cliente.atributos || []).forEach(attr => {
      Object.keys((attr && attr.valor) || {}).forEach(key => {
        attr.valor[key] = attr.valor[key].replace(/T\d{2}:\d{2}:\d{2}.\d{3}Z/g, '');
      });
    });

    CustomModal.open({
      title: 'Atributos del Cliente',
      size: 'lg',
      templateUrl: viewAtributosTemplate,
      vm: this,
      atributos: self.model.cliente.atributos.filter(a => a.tipo.mostrarEnTableroEspecialistas),
      ok: function () { }
    });
  }

  this.renderPaqueteCliente = renderPaqueteCliente.bind(this);

  function renderPaqueteCliente(paqueteCliente) {
    return `<div class="paquete">${paqueteCliente.paquete.codigo} (${paqueteCliente.paquete.servicio.nombre}) <div class="select-detalles"><small>Sesiones Pagadas: ${paqueteCliente.cantidadSesionesPagadas} - Sesiones Ejecutadas: ${paqueteCliente.cantidadSesionesEjecutadas}  <small/></div></div>`;
  }

  this.loadPaquetesCliente = loadPaquetesCliente.bind(this);

  function loadPaquetesCliente(query) {
    if (!this.model.cliente) return;

    let filter = Filter.path('estadoSesiones.value').like('Pendiente')
      .and(Filter.path('cliente.id').eq(this.model.cliente.id));

    if (query) {
      filter = filter.and(Filter.path('paquete.codigo').like(query)
        .or(Filter.path('paquete.servicio.nombre').like(query))
        .or(Filter.path('paquete.codigo').like(query)));
    }

    BasicFactory.setup('paquetes-cliente');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  this.onSelectPaqueteCliente = onSelectPaqueteCliente.bind(this);

  function onSelectPaqueteCliente() {
    this.localModel.categoria = this.localModel.paqueteCliente.paquete.servicio.categoria;
    this.localModel.nuevoDetalle.servicio = this.localModel.paqueteCliente.paquete.servicio;
    this.selectServicio();
  }

  this.changeTipoAgendamiento = changeTipoAgendamiento.bind(this);

  function changeTipoAgendamiento() {
    let self = this;

    for (var key in self.localModel.detalles) {
      let detalle = self.localModel.detalles[key];
      self.deleteDetalle(detalle);
    }

    this.localModel.nuevoDetalle.especialista = null;
    this.localModel.nuevoDetalle.servicio = null;
  }

  this.cancel = cancel.bind(this);

  function cancel() {
    $state.go($stateParams.next ? $stateParams.next : 'home.citas.list');
  }

  this.updateRUC = updateRUC.bind(this);
  function updateRUC() {
    this.localModel.payload.nombre = this.localModel.payload.ruc.nombre;
    this.localModel.payload.apellido = this.localModel.payload.ruc.apellido;
    this.localModel.payload.numeroDocumento = this.localModel.payload.ruc.numero;
    this.localModel.payload.razonSocial = `${this.localModel.payload.nombre ? this.localModel.payload.nombre : ''} ${this.localModel.payload.apellido ? this.localModel.payload.apellido : ''}`;

    if (this.localModel.payload.ruc.personaFisica) {
      this.localModel.payload.tipoPersona = this.tiposPersona.filter((v) => v.value === 'Física')[0];
    } else {
      this.localModel.payload.tipoPersona = this.tiposPersona.filter((v) => v.value === 'Jurídica')[0];
      this.localModel.payload.razonSocial = this.localModel.payload.ruc.razonSocial;
    }
  }

  this.loadRUC = loadRUC.bind(this);
  function loadRUC(query) {
    let filter;

    if (query) {
      filter = Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('numero').like(query));
    } else {
      return;
    }

    BasicFactory.setup('ruc');

    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function buscar(parametro) {
    if (parametro) {
      return $ngRedux.dispatch(rest.actions.search({ parametro: parametro }));
    } else {
      return;
    }
  }

  this.renderRUC = renderRUC.bind(this);
  function renderRUC(ruc) {
    let numeroDoc = ruc.numero && ruc.digitoVerificador ? ruc.numero + "-" + ruc.digitoVerificador : 'Sin Nro. Documento';
    return `${ruc.razonSocial} <small><strong>(${numeroDoc})</strong></small>`;
  }

  function renderTipoAtributo(tipo) {
    let detalle = tipo.abreviatura ? `<small><strong>(${tipo.abreviatura})</strong></small>` : '';
    return `${tipo.nombre} ${detalle}`;
  }

  function loadTipoAtributo(query) {

    if (query) {
      var filter = Filter.path('nombre').like(query);
      filter = filter.or(Filter.path('abreviatura').like(query));
    }
    BasicFactory.setup('tipos-atributos-cliente');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }
}



// WEBPACK FOOTER //
// ./src/components/citas/form/form.component.js